import { api } from "@/lib/api";

// §87 Anonymous demo watch tracking (personal links attach their token).
const SID = "rpopro_demo_sid", LINK = "rpopro_demo_link";
export const demoSession = () => {
  let s = localStorage.getItem(SID);
  if (!s) { s = `ds_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`; localStorage.setItem(SID, s); }
  return s;
};
export const demoLink = () => sessionStorage.getItem(LINK) || localStorage.getItem(LINK) || null;
export const setDemoLink = (t) => { sessionStorage.setItem(LINK, t); localStorage.setItem(LINK, t); };
export const demoAttribution = () => ({ demo_session: localStorage.getItem(SID) || null, demo_link: demoLink() });
export const trackDemo = (event, extra = {}) => api.post("/public/demo-events", { session_id: demoSession(), link_token: demoLink(), event, ...extra }).catch(() => {});
export const b64 = (s) => btoa(unescape(encodeURIComponent(s))).replace(/=+$/, "");
export const unb64 = (s) => { try { return decodeURIComponent(escape(atob(s))); } catch { return ""; } };
